/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type PeopleListItem_person$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PeopleList_viewer$ref: FragmentReference;
export type PeopleList_viewer = {|
  +persons: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: PeopleListItem_person$ref,
      |}
    |}>
  |},
  +$refType: PeopleList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "PeopleList_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "persons",
      "storageKey": "persons(first:-1)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": -1,
          "type": "Int"
        }
      ],
      "concreteType": "PersonConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PersonEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Person",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "PeopleListItem_person",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b0dc146ea0ae796529274427db873645';
module.exports = node;



// WEBPACK FOOTER //
// src/components/__generated__/PeopleList_viewer.graphql.js